import BootstrapTable from 'react-bootstrap-table-next';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Pagination from 'components/v2/Pagination';

const EventList = ({ rows, columns, paginate }) => {
  const {t} = useTranslation();
  const [localizedColumns, setLocalizedColumns] = useState(columns || [])
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [currentRows, setCurrentRows] = useState([]);
  const [showPagination, setShowPagination] = useState(paginate);

  useEffect(() => {
    if (paginate) {
      getPagesForRows(page);
    }
    setLocalizedColumns(columns.map(col => {
      const localized = t(col.text)
      return {
        ...col,
        text: localized.toUpperCase()
      }
    }))
  }, [rows, page]);

  const getPagesForRows = (page) => {
    setPages(getNumberOfPages(rows));
    let start = (page - 1) * 10;
    let activeRows = rows.slice(start, start + 10);
    rows.length >= 10 ? setCurrentRows(activeRows) : setCurrentRows(rows);
    setShowPagination(true);
  };
  const onPaginationSelect = (page) => {
    setPage(page);
  };

  const getNumberOfPages = (rows) => {
    const dif = rows.length - (Math.floor(rows.length / 10) * 10);
    return dif ? Math.floor(rows.length / 10) + 1 : Math.floor(rows.length / 10);
  };

  return (
    <div>
      <div className="table-hscrolling">
        {!paginate && (
          <BootstrapTable
            keyField={'_id'}
            data={rows}
            columns={localizedColumns}
            bordered={false}
            noDataIndication={t('NO_DATA_FOUND')}
            striped={true}
          />
        )}
        {paginate && currentRows.length ? (
          <div>
            <BootstrapTable
              keyField={'_id'}
              data={currentRows}
              columns={localizedColumns}
              bordered={false}
              noDataIndication={t('NO_DATA_FOUND')}
              striped={true}
            />
            <Pagination
              perPage={10}
              page={page}
              pages={pages}
              total={pages}
              onPageClick={(page) => onPaginationSelect(page)}
              showCount={false}
            />
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  );
};

export default EventList;
